import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@mui/material";
import React from "react";

import { MoveProgress } from "./app/move";

const phaseLabels: Record<MoveProgress["phase"], string> = {
  counting: "Counting files",
  overwriting: "Overwriting existing items",
  copying: "Copying files",
  deleting: "Deleting originals",
  done: "Done",
};

function MoveProgressDialog({ progress }: { progress: MoveProgress | null }) {
  const percent = progress?.total
    ? Math.round((progress.done / progress.total) * 100)
    : 0;

  return (
    <Dialog open={Boolean(progress)} disableEscapeKeyDown>
      <DialogTitle>Moving items</DialogTitle>
      <DialogContent sx={{ minWidth: 320 }}>
        <Typography color="text.secondary" sx={{ marginBottom: 2 }}>
          Please do not refresh or close this page.
        </Typography>
        <LinearProgress
          variant={
            progress?.phase === "counting" ? "indeterminate" : "determinate"
          }
          value={percent}
        />
        <Box
          sx={{ display: "flex", justifyContent: "space-between", marginTop: 1 }}
        >
          <Typography variant="body2">
            {progress?.done ?? 0} / {progress?.total ?? 0}
          </Typography>
          {progress?.phase !== "counting" && (
            <Typography variant="body2">{percent}%</Typography>
          )}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ marginTop: 1 }}>
          {progress ? phaseLabels[progress.phase] : ""}
        </Typography>
        {progress?.current && (
          <Typography variant="caption" color="text.secondary">
            {progress.current}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default MoveProgressDialog;
